import template from './assignmentConfirmation.html';
import controller from './assignmentConfirmation.controller';

let assignmentConfirmationComponent = () => {
  return {
    restrict: 'E',
    require: '^^entitler',
    scope: {},
    template,
    controller,
    controllerAs: 'vm',
    link: ($scope, $elem, $attrs, entitler) => {
      $scope.vm.entitler = entitler;
      $scope.vm.removeRecommendationFromSelectionList();
      let studentProductForUsers = (entitler.selectedProducts && entitler.selectedProducts.length && entitler.selectedProducts[0].edition === 'S' && entitler.currentTab === 'users');
      if (!entitler.manageLicenses && entitler.selectedProducts[0] && entitler.selectedProducts.length && entitler.selectedProducts[0].edition && !studentProductForUsers) {
        $scope.vm.findProductRecommendation();
      }
    }
  };
};

export default assignmentConfirmationComponent;



// WEBPACK FOOTER //
// ./app/components/assignmentConfirmation/assignmentConfirmation.component.js